export const formatIBAN = (iban?: string | null): string => {
    const ibanWithoutSpaces = String(iban || '').replace(/\s/g, '');

    return ibanWithoutSpaces.match(/.{1,4}/g)?.join(' ') ?? '';
};
